/** @jsx jsx */
import { css, jsx } from '@emotion/react'
import React from 'react'

export type VStackProps = {
  as?: React.ElementType<any>
  children: React.ReactNode
  gap?: string
  style?: React.CSSProperties
}

export const VStack = ({
  gap,
  as: Component = 'div',
  children,
  ...props
}: VStackProps) => {
  return (
    <Component
      css={css`
        display: grid;
        row-gap: ${gap || ''};
      `}
      {...props}
    >
      {children}
    </Component>
  )
}
